var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',[_c('dimssa-button',{staticClass:"button",attrs:{"buttonState":"disabled"}},[_vm._v("Rations")])],1)],1),_c('v-row',[_c('v-col',[_c('dimssa-button',{staticClass:"button",attrs:{"buttonState":"disabled"}},[_vm._v("Materials")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }